import * as z from "zod/v4";

export const ShopperAiWrappedImageKey = [
  "hero",
  "automation",
  "resolution",
  "cost",
  "conversion",
  "sales",
  "recommendation1",
  "recommendation2",
  "closing",
  "sentiment",
] as const;
export type ShopperAiWrappedImageKey =
  (typeof ShopperAiWrappedImageKey)[number];

export const ShopperAiWrappedImageKeySchema = z.enum(ShopperAiWrappedImageKey);

export const SHOPPER_AI_WRAPPED_IMAGE_URLS: Record<
  ShopperAiWrappedImageKey,
  string
> = {
  hero: "https://redoapi-dev.s3.amazonaws.com/redo/static/shopper-ai-wrapped/shopper-ai-wrapped-hero.webp",
  automation:
    "https://redoapi-dev.s3.amazonaws.com/redo/static/shopper-ai-wrapped/shopper-ai-wrapped-2.webp",
  resolution:
    "https://redoapi-dev.s3.amazonaws.com/redo/static/shopper-ai-wrapped/shopper-ai-wrapped-3.webp",
  cost: "https://redoapi-dev.s3.amazonaws.com/redo/static/shopper-ai-wrapped/shopper-ai-wrapped-4.webp",
  conversion:
    "https://redoapi-dev.s3.amazonaws.com/redo/static/shopper-ai-wrapped/shopper-ai-wrapped-5.webp",
  sales:
    "https://redoapi-dev.s3.amazonaws.com/redo/static/shopper-ai-wrapped/shopper-ai-wrapped-6.webp",
  recommendation1:
    "https://redoapi-dev.s3.amazonaws.com/redo/static/shopper-ai-wrapped/shopper-ai-wrapped-7.webp",
  recommendation2:
    "https://redoapi-dev.s3.amazonaws.com/redo/static/shopper-ai-wrapped/shopper-ai-wrapped-8.webp",
  closing:
    "https://redoapi-dev.s3.amazonaws.com/redo/static/shopper-ai-wrapped/shopper-ai-wrapped-9.webp",
  sentiment:
    "https://redoapi-dev.s3.amazonaws.com/redo/static/shopper-ai-wrapped/shopper-ai-wrapped-10.webp",
};

export const ShopperAiWrappedPageType = [
  "intro",
  "automation",
  "resolution",
  "cost",
  "sentiment",
  "conversion",
  "sales",
  "recommendation",
  "closing",
] as const;
export type ShopperAiWrappedPageType =
  (typeof ShopperAiWrappedPageType)[number];

export const ShopperAiWrappedPageTypeSchema = z.enum(ShopperAiWrappedPageType);
